/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 9/3/2022
 */


import {WorkflowStateItem} from "@shared/Workflow/WorkflowStateItem-imports";
import {WorkflowDocumentType} from "@shared/Workflow/WorkflowDocumentType";
import dayjs from "dayjs";
import {WorkflowStateEnum} from "@shared/Workflow/WorkflowStateEnum";
import {TaskJournalEntry} from "@shared/Journal/journalEntry-imports";


export default class TraumaWorkflowStateItem extends WorkflowStateItem {

	impairmentsStatus: string = null
	safetyRiskStatus: string = null

	requiresClientSafetyPlan: boolean = false
	requiresCrisisManagementPlan: boolean = false

	needAddFollowupImpairments: boolean = null
	needAddFollowupSafetyRisk: boolean = null

	impairmentsFollowupsSentCount: number = 0

	impairmentsNextFollowupTs: number = null
	safetyRiskNextFollowupTs: number = null
	escalatedCareFollowupTs: number = null

	escalatedCareStartedAt: number = null

	_isExpanded: boolean = false


	constructor() {
		super("TraumaWorkflowStateItem");
	}

	getSafetyRiskAssessmentDocRef() {
		return this.findDocRefByType(WorkflowDocumentType.SAFETY_RISK_ASSESSMENT)
	}

	getDailyLivingDocRef() {
		return this.findDocRefByType(WorkflowDocumentType.DAILY_LIVING)
	}

	getRecoveryGoalsDocRef() {
		return this.findDocRefByType(WorkflowDocumentType.RECOVERY_GOALS_WORKSHEET)
	}

	getCrisisManagementPlanDocRef() {
		return this.findDocRefByType(WorkflowDocumentType.CRISIS_MANAGEMENT_PLAN)
	}

	getClientSafetyPlanDocRef() {
		return this.findDocRefByType(WorkflowDocumentType.CLIENT_SAFETY_PLAN)
	}

	getBriefIntakeDocRef() {
		return this.findDocRefByType(WorkflowDocumentType.BRIEF_INTAKE_FORM)
	}

	getDetailedIntakeDocRef() {
		return this.findDocRefByType(WorkflowDocumentType.DETAILED_INTAKE_FORM)
	}

	isEscalatedCareFollowupDue() {
		let fwMaxTs = this.escalatedCareFollowupNoLaterThanTs()
		let timeNow = dayjs().valueOf()
		return timeNow >= fwMaxTs;
	}

	escalatedCareFollowupNoLaterThanTs() {
		return dayjs(this.escalatedCareStartedAt).add(48, "hour").valueOf();
	}

	escalatedCareFollowupNoLaterThanFormatted() {
		let ts = this.escalatedCareFollowupNoLaterThanTs()
		return ts ? dayjs(ts).format("MMM DD, YYYY") : ""
	}

	escalatedCareStartedFormatted() {
		let ts = this.escalatedCareStartedAt
		return ts ? dayjs(ts).format("MMM DD, YYYY") : ""
	}

	escalatedCareFollowupCompletedFormatted() {
		let ts = this.escalatedCareFollowupTs
		return ts ? dayjs(ts).format("MMM DD, YYYY") : ""
	}

	markFollowupCompleted() {
		this.escalatedCareFollowupTs = dayjs().valueOf();
	}

	setEscalatedCareCompleted() {
		this.workflowStatus = WorkflowStateEnum.ESCALATED_CARE_COMPLETED
	}

	isEscalatedCareCompleted() {
		return this.workflowStatus === WorkflowStateEnum.ESCALATED_CARE_COMPLETED
	}
	isEscalatedCare() {
		return this.workflowStatus === WorkflowStateEnum.ESCALATED_CARE
	}

	isSafetyRiskStatusEscalatedCare() {
		return this.safetyRiskStatus === WorkflowStateEnum.ESCALATED_CARE
	}

	isSafetyRiskStatusSafetyCare() {
		return this.safetyRiskStatus === WorkflowStateEnum.FOLLOWUP_30_SAFETY_RISK
	}

	syncSafetyRiskAndDailyLivingCompletionStatus() {

		let isSafetyCare = this.safetyRiskStatus === WorkflowStateEnum.FOLLOWUP_30_SAFETY_RISK
		let isEscalatedCare = this.safetyRiskStatus === WorkflowStateEnum.ESCALATED_CARE

		let safetyRiskAssessmentDocRef = this.getSafetyRiskAssessmentDocRef()
		let dailyLivingDocRef = this.getDailyLivingDocRef()

		console.log("syncSafetyRiskAndDailyLivingCompletionStatus: isSafetyCare = ", isSafetyCare, ", safetyRiskAssessmentDocRef.completionStatus = ", safetyRiskAssessmentDocRef.completionStatus, ", dailyLivingDocRef.completionStatus = ", dailyLivingDocRef.completionStatus)

		if(isEscalatedCare && safetyRiskAssessmentDocRef.isWaitingOther()){
			safetyRiskAssessmentDocRef.setCompleted()
			dailyLivingDocRef.setCompleted()
		} else if(safetyRiskAssessmentDocRef.isWaitingOther() && dailyLivingDocRef.isWaitingOther()){
			if(isSafetyCare){
				safetyRiskAssessmentDocRef.setRequiresFollowup()
			} else {
				safetyRiskAssessmentDocRef.setCompleted()
			}
			dailyLivingDocRef.setRequiresFollowup()
		} else if(safetyRiskAssessmentDocRef.isCompleted() && dailyLivingDocRef.isWaitingOther()){
			dailyLivingDocRef.setRequiresFollowup()
		}

		// if (isSafetyCare) {
		// 	if (safetyRiskAssessmentDocRef.isCompleted()) {
		// 		if (dailyLivingDocRef.isCompleted()) {
		// 			safetyRiskAssessmentDocRef.setRequiresFollowup()
		// 			dailyLivingDocRef.setRequiresFollowup()
		// 		} else {
		// 			dailyLivingDocRef.setNeedsRetakeSafetyCare()
		// 		}
		// 	}
		// } else if (isSafetyRiskStarted && dailyLivingDocRef.isCompleted()) {
		// 	dailyLivingDocRef.setRequiresFollowup()
		// }

		console.log("syncSafetyRiskAndDailyLivingCompletionStatus after: safetyRiskAssessmentDocRef.completionStatus = ", safetyRiskAssessmentDocRef.completionStatus, ", dailyLivingDocRef.completionStatus = ", dailyLivingDocRef.completionStatus)

	}

	setSafetyRiskStatus(status) {

		console.log("setSafetyRiskStatus: status = ", status)
		this.safetyRiskStatus = status
		this.syncSafetyRiskAndDailyLivingCompletionStatus()

		switch (status) {
			case WorkflowStateEnum.ESCALATED_CARE:
				this.needAddFollowupSafetyRisk = true
				this.needAddFollowupImpairments = false
				this.safetyRiskNextFollowupTs = dayjs().add(48, 'hour').valueOf()
				this.requiresCrisisManagementPlan = true
				break;
			case WorkflowStateEnum.FOLLOWUP_30_SAFETY_RISK:
				this.needAddFollowupSafetyRisk = true
				this.safetyRiskNextFollowupTs = dayjs().add(30, 'day').valueOf()
				this.requiresClientSafetyPlan = true
				break;
			default:
				this.needAddFollowupSafetyRisk = false
				this.safetyRiskNextFollowupTs = null
				break;
		}
		console.log("setSafetyRiskStatus: after this = ", this)


	}


	setImpairmentsStatus(status) {

		console.log("setImpairmentsStatus: status = ", status)

		if (!this.impairmentsStatus) {
			this.needAddFollowupImpairments = true
			this.impairmentsFollowupsSentCount = 0
		}

		this.impairmentsStatus = status

		this.syncSafetyRiskAndDailyLivingCompletionStatus()

		let daysCount

		switch (status) {
			case WorkflowStateEnum.FOLLOWUP_30_60_90_IMPAIRMENTS:
				this.needAddFollowupImpairments = true
				daysCount = this.impairmentsFollowupsSentCount >= 3 ? 90 : 30
				this.impairmentsNextFollowupTs = dayjs().add(daysCount, 'day').valueOf()
				this.impairmentsFollowupsSentCount++
				break;
			case WorkflowStateEnum.FOLLOWUP_30_90_IMPAIRMENTS:
				this.needAddFollowupImpairments = true
				daysCount = this.impairmentsFollowupsSentCount >= 2 ? 90 : 30
				this.impairmentsNextFollowupTs = dayjs().add(daysCount, 'day').valueOf()
				this.impairmentsFollowupsSentCount++
				break;
			case WorkflowStateEnum.FOLLOWUP_90:
				this.needAddFollowupImpairments = true
				this.impairmentsNextFollowupTs = dayjs().add(90, 'day').valueOf()
				this.impairmentsFollowupsSentCount++
				break;
			default:
				this.needAddFollowupImpairments = false
				this.impairmentsNextFollowupTs = null
				break;
		}

		this.getDailyLivingDocRef().followupsSentCount = this.impairmentsFollowupsSentCount

		console.log("setImpairmentsStatus: after this = ", this)


	}

	syncOverallStatus() {

		let safetyRiskStatus = this.safetyRiskStatus
		let impairmentsStatus = this.impairmentsStatus

		let initialStatus = this.workflowStatus

		console.log("syncOverallStatus: safetyRiskStatus = ", safetyRiskStatus, ", impairmentsStatus = ", impairmentsStatus, ", initialStatus = ", initialStatus)
		if (safetyRiskStatus == null) {
			console.log("syncOverallStatus: safetyRiskStatus is null, skipping...")
			return false
		}

		let isEscalatedCare = safetyRiskStatus === WorkflowStateEnum.ESCALATED_CARE
		let isSafetyCare = safetyRiskStatus === WorkflowStateEnum.FOLLOWUP_30_SAFETY_RISK

		if (isEscalatedCare || isSafetyCare) {
			if (isEscalatedCare && this.workflowStatus !== isEscalatedCare) {
				this.escalatedCareStartedAt = new Date().getTime()
			}
			this.workflowStatus = safetyRiskStatus
		} else if (impairmentsStatus) {
			if (impairmentsStatus === WorkflowStateEnum.FOLLOWUP_30_90_IMPAIRMENTS && this.impairmentsFollowupsSentCount >= 2
				|| impairmentsStatus === WorkflowStateEnum.FOLLOWUP_30_60_90_IMPAIRMENTS && this.impairmentsFollowupsSentCount >= 3) {
				this.workflowStatus = WorkflowStateEnum.FOLLOWUP_90
			} else {
				this.workflowStatus = impairmentsStatus
			}
		}

		console.log("syncOverallStatus: after this.workflowStatus = ", this.workflowStatus)

		return initialStatus !== this.workflowStatus

	}

	flushFollowupJournalEntry() {
		console.log("flushFollowupJournalEntry start: TraumaWorkflowStateItem = ", this)

		let dailyLivingDocRef =  this.getDailyLivingDocRef()
		let safetyRiskAssessmentDocRef =  this.getSafetyRiskAssessmentDocRef()

		let isWaitingOther = dailyLivingDocRef.isWaitingOther() || safetyRiskAssessmentDocRef.isWaitingOther()

		if (isWaitingOther || !this.needAddFollowupSafetyRisk && !this.needAddFollowupImpairments) {
			console.log("flushFollowupJournalEntry: skipping")
			return
		}
		let dueDateTs
		let title

		let journalEntry = new TaskJournalEntry()

		if (this.needAddFollowupSafetyRisk && this.isEscalatedCare()) {
			dueDateTs = this.safetyRiskNextFollowupTs
			title = "Followup with client: Escalated Care"
			journalEntry.setPriorityUrgent()
			this.needAddFollowupSafetyRisk = false
		} else if (this.needAddFollowupSafetyRisk) {
			dueDateTs = this.safetyRiskNextFollowupTs
			title = "Followup with client: Safety Risk Assessment"
			this.needAddFollowupSafetyRisk = false
		} else if (this.needAddFollowupImpairments) {
			dueDateTs = this.impairmentsNextFollowupTs
			title = "Followup with client: Activities of Daily Living"
			this.needAddFollowupImpairments = false
		}

		journalEntry.description = title
		journalEntry.isEditable = false
		journalEntry.dueDateTs = dueDateTs
		journalEntry.clientId = this.clientId
		journalEntry.clientName = this.clientName
		journalEntry.attachedWorkflowId = this.workflowId
		journalEntry.workflowStateItemId = this.id
		journalEntry.enableCoachJournalDisplayDestination()

		this.journalEntryId = journalEntry.id

		console.log("flushFollowupJournalEntry: journalEntry = ", journalEntry)

		return journalEntry
	}

	getNextFollowupTs() {
		return this.escalatedCareFollowupTs || this.safetyRiskNextFollowupTs || this.impairmentsNextFollowupTs
	}

	nextFollowupDateFormatted(){
		if(this.getNextFollowupTs()){
			return "on " + dayjs(this.getNextFollowupTs()).format("MMM DD, YYYY")
		}
		return "not set"
	}

	nextDocRefsArray() {
		let arr = []

		let safetyRiskAssessmentDocRef = this.getSafetyRiskAssessmentDocRef()
		let dailyLivingDocRef = this.getDailyLivingDocRef()

		if (safetyRiskAssessmentDocRef.isRequiresFollowup()) {
			if (this.isSafetyRiskStatusSafetyCare()) {
				safetyRiskAssessmentDocRef._tooltipText = "Your client's last result triggered the 'Safety Care Plan' which requires retaking Safety Risk Assessment in 30 days."
			}
			arr.push(safetyRiskAssessmentDocRef)
		}
		if (!dailyLivingDocRef.isCompleted()) {
			arr.push(dailyLivingDocRef)
		}
		return arr

	}



}
